import React from 'react';
import { SocialNetwork } from '../../config/socialLinks';

interface IconProps {
  network: SocialNetwork;
}

const SocialIcons: React.FC<IconProps> = ({ network }) => {
  if (network === 'instagram') {
    return (
      <svg data-testid="social-icon-instagram" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M7 3h10a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm10 2H7a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V7a2 2 0 0 0-2-2zm-5 3.2A3.8 3.8 0 1 1 8.2 12 3.8 3.8 0 0 1 12 8.2zm0 2A1.8 1.8 0 1 0 13.8 12 1.8 1.8 0 0 0 12 10.2zM17.2 6.6a1 1 0 1 1-1 1 1 1 0 0 1 1-1z"
        />
      </svg>
    );
  }

  if (network === 'tiktok') {
    return (
      <svg data-testid="social-icon-tiktok" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M14.5 3h2.1a5.2 5.2 0 0 0 3.4 3.2v2.2a7.3 7.3 0 0 1-3.4-1v6.4a5.8 5.8 0 1 1-5.8-5.8c.2 0 .5 0 .7.1v2.3a3.5 3.5 0 1 0 2.5 3.4V3z"
        />
      </svg>
    );
  }

  if (network === 'facebook') {
    return (
      <svg data-testid="social-icon-facebook" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path
          fill="currentColor"
          d="M14.2 21v-7.2h2.4l.4-2.8h-2.8V9.2c0-.8.2-1.4 1.4-1.4H17V5.2A18.4 18.4 0 0 0 14.9 5C12.6 5 11 6.4 11 9v2H8.6v2.8H11V21z"
        />
      </svg>
    );
  }

  return (
    <svg data-testid="social-icon-pinterest" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        fill="currentColor"
        d="M12 3a9 9 0 0 0-3.3 17.4c-.1-.7-.2-1.8 0-2.6l1.4-5.8s-.3-.7-.3-1.7c0-1.6.9-2.8 2.1-2.8 1 0 1.5.7 1.5 1.6 0 1-.6 2.4-.9 3.7-.3 1.1.5 2 1.6 2 1.9 0 3.2-2.4 3.2-5.3 0-2.2-1.5-3.8-4.2-3.8A4.6 4.6 0 0 0 7.6 11c0 .9.3 1.8.7 2.3a.3.3 0 0 1 .1.3l-.2.9c-.1.2-.2.3-.4.2-1.3-.5-1.9-1.9-1.9-3.5 0-2.6 2.2-5.8 6.6-5.8 3.5 0 5.8 2.5 5.8 5.3 0 3.6-2 6.3-5 6.3-1 0-1.9-.5-2.3-1.2l-.6 2.4a9 9 0 0 0 1.6.2 9 9 0 0 0 0-18z"
      />
    </svg>
  );
};

export default SocialIcons;
